import{jsxs as e,jsx as t}from"react/jsx-runtime";import{twJoin as a}from"tailwind-merge";import{LeftArrow as i,PaginationNumber as n,RightArrow as r}from"./Pagination.parts.js";import{getPageButtonCount as s,getFirstPage as o,getLastPage as m}from"./Pagination.utils.js";
/**
 * 페이지네이션 컴포넌트
 *
 * @description
 * 여러 페이지로 구성된 콘텐츠를 탐색할 수 있는 페이지네이션 컴포넌트입니다.
 * 좌우 화살표와 페이지 번호 버튼으로 구성되어 있으며, 현재 페이지가 강조 표시됩니다.
 *
 * @param {Object} props
 * @param {number} props.maxPage - 전체 페이지 수
 * @param {number} [props.pageCount=10] - 한 번에 표시할 페이지 버튼의 개수 (기본값: 10)
 * @param {number} props.page - 현재 페이지 번호
 * @param {(page: number) => void} props.onChange - 페이지 변경 시 호출되는 콜백 함수
 *
 * @example
 * ```tsx
 * <Pagination
 *   maxPage={100}
 *   pageCount={5}
 *   page={1}
 *   onChange={(page) => setCurrentPage(page)}
 * />
 * ```
 */const l=({maxPage:l,pageCount:p=10,page:c,onChange:g})=>{const d=1===c,f=c===l,u=o(c,p),C=m(u,p,l),j=s(u,C);/*#__PURE__*/
return e("div",{"data-testid":"design-system-pagination",className:"flex items-center justify-center gap-2",children:[
/*#__PURE__*/t(i,{onClick:()=>{d||g(c-1)},className:a("p-3",d&&"invisible")}),Array.from({length:j}).map(((e,a)=>{const i=u+a;/*#__PURE__*/
return t(n,{"data-testid":`page-${i}`,value:i,enabled:i===c,onClick:()=>g(i)},i)})),
/*#__PURE__*/t(r,{onClick:()=>{f||g(c+1)},className:a("p-3",f&&"invisible")})]})};export{l as Pagination};
